import { render, staticRenderFns } from "./RealtimeDataSection.vue?vue&type=template&id=8233d63e&scoped=true&"
import script from "./RealtimeDataSection.vue?vue&type=script&lang=js&"
export * from "./RealtimeDataSection.vue?vue&type=script&lang=js&"
import style0 from "./RealtimeDataSection.vue?vue&type=style&index=0&id=8233d63e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8233d63e",
  null
  
)

export default component.exports